import http from "@/apis/http";
import url from "@/config/url";

const api = url.tgBusiness.member.privilege;

export default {
  getColumns: (params) => http.post(api.columns, params),
  getData: (params) => http.post(api.search, params),
  changePrivilege: (params) => http.post(api.action, { ...params, isBulk: false }),
  bulkChangePrivilege: (params) => http.post(api.action, { ...params, isBulk: true }),
  find: (params) => http.post(api.find, params),
  unlock: (params) => http.post(api.unlock, params),
};
